import { cn } from '@hrms/ui';

/**
 * Standardized styling for all PeopleOrbit desktop sidebar navigation items.
 *
 * Uses the canonical "Payslip" navigation item as the visual sizing reference:
 * - Full container width (`w-full`)
 * - Left/right horizontal padding (`px-2`)
 * - Vertical padding (`py-1.5`)
 * - Icon-to-text gap (`gap-2.5`)
 * - Border radius (`rounded-lg`)
 * - Typography (`text-xs font-medium`)
 * - Active background (`bg-sidebar-active-bg font-semibold text-sidebar-active-fg`)
 * - Inactive hover background (`text-sidebar-fg-muted hover:bg-sidebar-hover-bg hover:text-sidebar-fg`)
 *
 * This ensures every item (Payslip, Attendance, Projects, Leave, Assets, Performance, etc.)
 * occupies the exact same horizontal container space and active/hover dimensions regardless of
 * text length or whether it renders a direct link or a flyout menu.
 */
export const SIDEBAR_NAV_ITEM_BASE =
  'flex w-full items-center gap-2.5 rounded-lg px-2 py-1.5 text-xs font-medium transition-all';

export const SIDEBAR_NAV_ITEM_ACTIVE = 'bg-sidebar-active-bg font-semibold text-sidebar-active-fg';

export const SIDEBAR_NAV_ITEM_INACTIVE =
  'text-sidebar-fg-muted hover:bg-sidebar-hover-bg hover:text-sidebar-fg';

export function getSidebarNavItemClasses(isActive: boolean, extraClasses?: string) {
  return cn(
    SIDEBAR_NAV_ITEM_BASE,
    isActive ? SIDEBAR_NAV_ITEM_ACTIVE : SIDEBAR_NAV_ITEM_INACTIVE,
    extraClasses,
  );
}
